import * as React from 'react';
import intl from 'react-intl-universal';

import { ReactComponent as SuccessBg } from '@svg/pc_questionnaire_success.svg';

import './index.less';

const Success: React.FC = () => {
    return (
        <div className="pc-success-wrapper">
            <SuccessBg />
            <p className="success-title">{intl.get('success')}</p>
        </div>
    );
};

export default Success;
